import {
    createTheme,
    Theme,
} from "@mui/material/styles";

export const facebookButton = "#1877f2";

declare module "@mui/material/styles/createPalette" {
    interface Palette {
        menuActive: {
            main: string;
            text: string;
        };
        menuInactive: {
            main: string;
            text: string;
        };
        card: {
            main: string;
            background: string;
            text: string;
            secondary: string;
            active: string;
            inactive: string;
            success: string;
            warning: string;
        };
        websiteBackground: {
            main: string;
        };
        button: {
            primary: string;
            secondary: string;
            inactive: string;
            active: string;
            hover: string;
            error: string;
            success: string;
            text: string;
        };
    }

    interface PaletteOptions {
        menuActive?: {
            main: string;
            text: string;
        };
        menuInactive?: {
            main: string;
            text: string;
        };
        card: {
            main: string;
            background: string;
            text: string;
            secondary: string;
            active: string;
            inactive: string;
            success: string;
            warning: string;
        };
        websiteBackground: {
            main: string;
        };
        button: {
            primary: string;
            secondary: string;
            inactive: string;
            active: string;
            hover: string;
            error: string;
            success: string;
            text: string;
        };
    }
}

const theme: Theme = createTheme({
    palette: {
        primary: {
            main: "rgba(63,52,86,0.8)",
        },
        secondary: {
            main: "rgba(101,100,108,0.8)",
        },
        grey: {
            50: "#fafafa",
            100: "#f5f5f5",
            200: "#eeeeee",
            300: "#e0e0e0",
            400: "#bdbdbd",
            500: "#9e9e9e",
        },
        success: {
            main: "rgba(0,173,20,0.8)",
        },
        info: {
            main: "rgba(86,56,152,0.8)",
        },
        warning: {
            main: "rgb(255,152,0)",
        },
        error: {
            main: "rgb(199,0,0)",
        },
        common: {
            white: "#ffffff",
            black: "#000000",
        },
        menuActive: {
            main: "#8ea4c0",
            text: "#ffffff",
        },
        menuInactive: {
            main: "rgba(0, 0, 0, 0)",
            text: "inherit",
        },
        websiteBackground: {
            main: "#fafafa",
        },
        card: {
            background: "#f5f5f5",
            text: "#000000",
            main: "#ffffff",
            secondary: "#e7e7e7",
            active: "#ffffff",
            inactive: "#ffffff",
            success: "#ffffff",
            warning: "#ffffff",
        },
        button: {
            primary: "#607D8B",
            secondary: "#636d73",
            inactive: "#ffffff",
            active: "#ffffff",
            hover: "#739baf",
            error: "#ffffff",
            success: "#00ff49",
            text: "#ffffff",
        },

    },
    typography: {
        fontFamily: "Roboto, Arial, sans-serif",
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "uppercase",
                },
            },
        },
    },
});

export default theme;
